import React from "react";
import SideNav from '../../shared/Sidenav';
import '../../../css/termsConditions/TermsConditions.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import addEnable from '../../../assets/images/add.svg';
import addDisable from '../../../assets/images/plus_disable.svg';
import TermsConditionsData from './TermsConditionsData';
import SuccessModal from '../../shared/SuccessModal';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { toast } from "react-toastify";
import { utilityBaseURL, baseURL } from '../../../Services/config/apiGateway';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
import { ApiCall } from '../../../Services/utils/ApiCall';
import Cookies from 'cookies-js';
import { GET_TERMS_AND_CONDITION, DOWNLOAD_ENDPOINT } from '../../../Services/config/apiEndPoints';
import Loader from 'react-loader';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
toast.configure();
var pageDisable = false;
var loaderTime = false;
var editEnable = '';
let viewOnly = false;
class TermsConditions extends React.Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            hasOpen: false,
            confirmedHasOpen: false,
            TermsAndConditionData: [],
            currentDate: "",
            isEdit: false,
            editIndex: '',
            editEnable: '',
            pdfURL: utilityBaseURL + DOWNLOAD_ENDPOINT + "?documentPath=",
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({
                showFromCalender: false, showToCalender: false,
            });
        }
    };
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        window.location.reload();
    };
    onUpdateTermsConditions = () => {
        this.setState({ hasOpen: true, isEdit: false });
    }
    onEditClicked = (index) => {
        this.setState({ hasOpen: true, isEdit: true, editIndex: index });
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 16) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        ApiCall(
            'GET',
            baseURL + GET_TERMS_AND_CONDITION,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                }
                else {
                    console.log('I am 200!');
                    console.log(data)
                    this.setState({ TermsAndConditionData: data })
                }
            }
            else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
        this.setState({ currentDate: new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date()).toString().substring(0, 10) });
    }
    getDate = (dateString) => {
        //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
        let dateParts = dateString.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    getTime = (timeStamp) => {
        return new Date(Number(timeStamp)).toGMTString().split(' ')[4].substring(0, 5);
    }
    getCreationDate = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toGMTString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    dateCompare = (d1, d2) => {
        let dateParts1 = d1.split("/");
        let dateParts2 = d2.split("/");
        let dateFoemate1 = new Date(dateParts1[2], dateParts1[1] - 1, dateParts1[0]).toString();
        let dateFoemate2 = new Date(dateParts2[2], dateParts2[1] - 1, dateParts2[0]).toString();
        const date1 = new Date(dateFoemate1);
        const date2 = new Date(dateFoemate2);
        if (date1 > date2) {
            return true;
        }
        else if (date1 < date2) {
            return false;
        }
        else {
            return false;
        }

    }
    previewPdf(index) {
        pageDisable = true
        loaderTime = true
        this.setPdfLoaderTrue(index)
    }
    setPdfLoaderTrue = (index) => {
        let testAccess = Cookies.get('msAL_admin_dev');
        testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
        var oReq = new XMLHttpRequest();
        var URLToPDF = this.state.pdfURL + this.state.TermsAndConditionData[index].termsFile;
        oReq.open("GET", URLToPDF, true);
        oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
        // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
        oReq.responseType = "blob";
        oReq.onload = function () {
            // Once the file is downloaded, open a new window with the PDF
            // Remember to allow the POP-UPS in your browser
            const file = new Blob([oReq.response], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_blank");
            pageDisable = false
            loaderTime = false
        }
        oReq.send();
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-wwhite" id="tableeHeader">
                    <td id="coll1" className="tableeHeading">S. No</td>
                    <td id="coll2" className="tableeHeading">Created Date & Time</td>
                    <td id="coll3" className="tableeHeading">Effective Date</td>
                    <td id="coll4" className="tableeHeading">Expiry Date</td>
                    <td id="coll5" className="tableeHeading">PDF</td>
                    <td></td>
                </tr>
            </>
        )
    }
    render() {
        const renderTableData = this.state.TermsAndConditionData.map((todo, index) => {
            return (
                <>
                    <tr key={index} id="termsCondotionsdata">
                        <td id="termscol1" className="tableedata">{index + 1}</td>
                        <td id="termscol2" className="tableedata">{this.getCreationDate(todo.creationTime)}&nbsp;&nbsp;{this.getTime(todo.creationTime)}</td>
                        <td id="termscol3" className="tableedata">{this.getDate(todo.effectiveFrom)}</td>
                        <td id="termscol4" className="tableedata">{todo.effectiveTo.length > 0 ? this.getDate(todo.effectiveTo) : ""}</td>
                        <td id className="previeww">
                            <Link
                                onClick={() => this.previewPdf(index)}
                            >View</Link></td>
                        <td style={{ display: !viewOnly ? "none" : null }}>
                            <div class="editablecoll" id="coll6" style={{ display: this.dateCompare(todo.effectiveFrom, this.state.currentDate) ? "table-row" : "none" }}>
                                <img class="" src={require('../../../assets/images/edit.svg')} width="" height="" class="d-inlinne-block mr-1 " alt="" loading="lazy" alt="Edit Icon" id="termsConditionsEditIcon"
                                    onClick={() => this.onEditClicked(index)} />
                            </div>
                        </td>
                    </tr>
                </>
            )
        });
        return (
            <div className="outerr1" id={pageDisable ? "disabletrue" : ""}><div className="outerr1" id="outerrdiv">
                <MetaDecorator title={TitleDescription.termsConditionsPageTitle} description={TitleDescription.termsConditionsPageDescription} />
                <Loader
                    loaded={!loaderTime}
                    lines={10}
                    length={10}
                    width={10}
                    radius={10}
                    corners={1}
                    rotate={0}
                    direction={1}
                    color="#000"
                    speed={1}
                    trail={60}
                    shadow={false}
                    hwaccel={false}
                    className='spinner'
                    zIndex={2e9}
                    top="50%"
                    left="50%"
                    scale={1.0}
                    loadedClassName="loadedContent"
                />
                <div className="dhome">
                    <SideNav />
                    <div id="termsConditionsPart">
                        <h1 id='termsConditionsTitle'>Terms & Conditions</h1>
                        {/* View Only Access */}
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <div className="contenntbox">
                            <table className='termsConditionsDetails'>
                                <tbody>
                                    {this.renderTableHeader()}
                                </tbody>
                            </table>
                            <div id="termsConditionsDataContainer">
                                <table className='termsConditionsDetails'>
                                    <tbody>
                                        {renderTableData}
                                    </tbody>
                                </table>
                            </div>
                            <div id="tableeFooter">
                                <div style={{ display: !viewOnly ? "none" : null }}>
                                    <Link onClick={this.onUpdateTermsConditions}
                                        style={{ pointerEvents: this.state.TermsAndConditionData.map(date => this.dateCompare(date.effectiveFrom, this.state.currentDate))[0] ? "none" : null }}>
                                        <img src={this.state.TermsAndConditionData.map(date => this.dateCompare(date.effectiveFrom, this.state.currentDate))[0] ? addDisable : addEnable} alt="Add Icon" width="19" height="19" id="" />
                                        <small className="updateTermsConditionsText" style={{ color: this.state.TermsAndConditionData.map(date => this.dateCompare(date.effectiveFrom, this.state.currentDate))[0] ? "#B6B6B6" : "#428BCA" }}>Update Terms & Conditions</small>
                                    </Link>
                                </div>
                                <div class="termsConditionsNotesDiv">
                                    <div>
                                        <small class="termConditionsNoteText">Note:</small>
                                    </div>
                                    <small class="termConditionsNoteOne">(1) Future scheduled “Terms & Conditions” line item is only editable.</small>
                                </div>
                                <div>
                                    <small class="termConditionsNoteTwo">(2) Any update in “Terms & Conditions” cannot be scheduled more than once for future.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.hasOpen ? <TermsConditionsData onClick={this.onCloseModal} isEditMode={this.state.isEdit} editValue={this.state.TermsAndConditionData[this.state.editIndex]} onClosePublish={this.onCloseModal} /> : null}
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmmedText">Confirmed</p>
                </SuccessModal>
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(TermsConditions);